import { DialogComponent } from '@theme/dialog';

export class CustomSizeGuideDialog extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.#scopeCategoryInputs();
  }

  #scopeCategoryInputs() {
    const inputs = this.querySelectorAll('.mox-size-guide__cat-input');
    if (!inputs.length) return;

    const scope = this.id;

    for (const input of inputs) {
      if (scope && !input.name.endsWith(`--${scope}`)) {
        input.name = `${input.name}--${scope}`;
      }
    }

    if (!this.querySelector('.mox-size-guide__cat-input:checked')) {
      inputs[0].checked = true;
    }
  }
}

if (!customElements.get('custom-size-guide-dialog')) {
  customElements.define('custom-size-guide-dialog', CustomSizeGuideDialog);
}
